module.exports = __webpack_public_path__ + "static/media/photo.5c8bd3c8.jpg";